var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RowItemAligned',{staticClass:"row-item",attrs:{"labels":_vm.technicalDataLabels,"values":_vm.technicalDataValues,"editable":true,"last":_vm.isLast},on:{"edit":function($event){return _vm.$emit('edit')}}})}
var staticRenderFns = []

export { render, staticRenderFns }